import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ForbiddenPage() {
  useEffect(() => {
    document.title = 'Adgang nægtet (403) - Health4media.dk';
  }, []);

  return (
    <div className="bg-slate-50 min-h-[75vh] flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="text-5xl text-amber-600 mx-auto">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            Adgang nægtet
          </h1>
          <p className="text-sm text-slate-600 leading-relaxed">
            Du har ikke tilladelse til at tilgå denne ressource. Hvis du mener, dette er en fejl, er du velkommen til at kontakte os.
          </p>
        </div>

        <div className="pt-4 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-slate-900 text-white font-semibold text-sm hover:bg-sky-700 transition shadow-xs"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white border border-slate-300 text-slate-700 font-semibold text-sm hover:bg-slate-50 transition"
          >
            <span>Kontakt os</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
